<ui-input-wrapper
  [label]="base.label"
  [labelTemplate]="base.labelTemplate"
  [help]="base.help"
  [helpTooltipPosition]="base.helpTooltipPosition()"
  [hint]="base.hint"
  [errors]="control.errors"
  [submitted]="submitted"
  [control]="control"
  [randomInputId]="randomInputId">
  <p-select
    #selectRef
    class="flex max-w-full min-w-46.25 max-lg:min-w-0"
    [options]="select.options()"
    [formControl]="$any(control)"
    [optionValue]="dropdown.bindValue()"
    appendTo="body"
    [showClear]="dropdown.clearable"
    [autoOptionFocus]="true"
    [focusOnHover]="false"
    [filter]="select.searchable()"
    [class]="base.styleClass()"
    [panelStyleClass]="dropdown.panelStyleClass()"
    [placeholder]="base.placeholder ? base.placeholder : 'Vyberte'"
    [overlayOptions]="{
      baseZIndex: 10004,
    }"
    [emptyMessage]="select.emptyMessage() ?? ''"
    [readonly]="base.readonly()"
    emptyFilterMessage="Nebyla nalezena shoda"
    (onChange)="handleChange.emit($event)"
    (onShow)="dropdown.dropdownStateChange.emit(dropdownState.Opened)"
    (onHide)="dropdown.dropdownStateChange.emit(dropdownState.Closed)"
    [optionLabel]="dropdown.bindLabel()"
    [inputId]="randomInputId">
    <ng-template #item let-option>
      <div [pTooltip]="option.tooltip ?? null">
        {{ option.label }}
      </div>
    </ng-template>
  </p-select>
</ui-input-wrapper>
